import { registerAnalyticsAdapter } from "utils/analytics"
import recorderAnalyticsAdapter from "./recorder"
import sentryAnalyticsAdapter from "./sentry"

// Imported first by the application pack, so the adapters are registered
// before any other module reports an event.
registerAnalyticsAdapter(sentryAnalyticsAdapter)
registerAnalyticsAdapter(recorderAnalyticsAdapter)
